export function viewSharingState({ shareId, shareOwner, shareVisibility, shareLoading, publishing }) {
  const status = shareLoading ? 'saving' : !shareId ? 'unsaved' : shareVisibility === 'public' ? 'public' : 'unlisted';
  const titles = {
    saving: 'Saving a shareable link',
    unsaved: 'Save a link to this View',
    public: 'Shared with other visitors',
    unlisted: shareOwner ? 'Keep or share this View' : 'Shared by link',
  };
  const showPublish = Boolean(shareOwner && shareId && status === 'unlisted');
  return {
    status,
    title: titles[status],
    canCopy: Boolean(shareId && !shareLoading),
    canRetry: Boolean(shareOwner && status === 'unsaved'),
    showPublish,
    canPublish: showPublish && !publishing,
  };
}
